import { getLastPart } from '@shared/shop-api/core/helper'
import {
  type FilterFragment,
  type FilterValue,
} from '@shared/types/storefront/graphql'

export const toProductFilter = (
  filter: FilterFragment,
  baseFilter?: FilterFragment
) => {
  return {
    id: filter.id,
    type: filter.type,
    label: filter.label,
    name: idToName(filter.id),
    presentation: filter.presentation ?? undefined,
    values: filter.values.map(toProductFilterValue),
    default: baseFilter?.values
      ? baseFilter.values.map(toProductFilterValue)
      : undefined,
  }
}

export const toProductFilterValue = (value: FilterValue) => {
  const input = JSON.parse(value.input)

  return {
    id: value.id,
    name: idToName(value.id),
    label: value.label,
    count: value.count,
    input,
  }
}

export const toFilterInput = (filter: string) => {
  const [filterId, value] = filter.split('=')
  const filterIdParts = filterId.split('.')
  const input = getFilterInput(filterId, filterIdParts, value)
  if (!input) {
    return
  }

  return input
}

const getFilterInput = (
  filterId: string,
  filterIdParts: string[],
  value: string
) => {
  if (filterId.includes('p.m')) {
    return getProductMetafieldInput(filterIdParts, value)
  }
  if (filterId.includes('v.m')) {
    return getVariantMetafieldInput(filterIdParts, value)
  }
  if (filterId.includes('v.option')) {
    return getProductOptionInput(value)
  }

  if (filterId.includes('v.price')) {
    return getPriceInput(value)
  }

  if (filterId.includes('v.availability')) {
    return getAvailabilityInput(value)
  }

  return
}

const getProductMetafieldInput = (filterIdParts: string[], value: string) => {
  const key = filterIdParts.pop()!
  const namespace = filterIdParts.pop()!
  return { productMetafield: { namespace, key, value } }
}

const getVariantMetafieldInput = (filterIdParts: string[], value: string) => {
  const key = filterIdParts.pop()!
  const namespace = filterIdParts.pop()!
  return { variantMetafield: { namespace, key, value } }
}

const getProductOptionInput = (value: string) => {
  return { variantOption: { name: 'size', value } }
}

const getPriceInput = (value: string) => {
  const values = value.split(',')
  const min = Number(values[0])
  const max = Number(values[1])
  return { price: { min, max } }
}

const getAvailabilityInput = (value: string) => {
  const available = Boolean(Number(value))
  return { available }
}

const idToName = (id: string) => getLastPart(id, '.')
